<template>
  <div>
    <h3 class="d-flex">
      {{ author.title }} {{ author.firstName }}
      {{ author.lastName }}
      <small>
        <v-chip
          class="mx-1 text-uppercase"
          x-small
          v-if="author.isCorresponding"
        >
          Corresponding author
        </v-chip>
      </small>
      <v-spacer></v-spacer>
      <v-btn
        v-if="creating"
        small
        rounded
        outlined
        color="red"
        @click="removeAuthor"
      >
        Remove
      </v-btn>
    </h3>
    <address>
      <p>{{ author.institution }}</p>
      <p>
        {{ author.department }}
        <span v-if="author.specialization">
          &mdash; Specializing in {{ author.specialization }}
        </span>
      </p>

      <p>
        {{ author.email }} <span v-if="author.phone">| {{ author.phone }}</span>
      </p>
    </address>
  </div>
</template>

<script>
import { manuscriptAuthor } from "../../../tools/manuscript";

export default {
  props: {
    author: {
      type: Object,
      default: () => manuscriptAuthor,
    },
    creating: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    removeAuthor() {
      this.$emit("remove", this.author);
    },
  },
};
</script>

<style lang="scss" scoped>
address {
  margin-top: 6px;

  p {
    padding: 0;
    margin: 5px 0;
    line-height: 1.3;
  }
}

li {
  padding: 1em 0;
}

li + li {
  border-top: 1px solid #dddddd;
}
</style>